import generateId from '@stitch-fix/log-weasel';
import { ApolloLink } from '@apollo/client';

const logWeaselLink = new ApolloLink((operation, forward) => {
  // Example: 'kept-items-ui:web'
  const name = operation.getContext().clientAwareness.name;
  // The ':' causes two problems:
  //   1) it gets removed by the time it shows up in datadog as `log_weasel_id` metadata
  //   2) it gets url encoded to '%3A' when used to generate a cookie name for algo tracking
  const sanitizedName = name.replace(':', '-');

  operation.setContext(({ headers }: { headers?: Record<string, string> }) => ({
    headers: {
      'X-Request-Id': generateId(sanitizedName),
      ...headers,
    },
  }));

  return forward(operation);
});

export default logWeaselLink;
